export default {
  computed: {
    serviceTypes () {
      return [
        { code: 'OZ', name: 'Origin All-In' },
        { code: 'DZ', name: 'Destination All-In' },
        { code: 'WA', name: 'Freight' },
        { code: 'AC', name: 'Accessorials' },
        { code: 'ST', name: 'Storage' }
      ]
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/admin/components/QuoteTax/mixin.js